import { useState, useEffect, useContext } from "react";
import "./NewRequest.css";
import { COSMOS_API, POST_ENDPOINT } from "../api/API";
import { AdminContext } from "../contexts/AdminContext";
import PopUp from "./PopUp";
import {
  AllUserApplicationRequests,
  UserApplicationRequests,
  UserGroupRequests
} from "../interfaces/APIInterface";
import { country_options } from "../data/countries";
import { useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import RequestActionGroup from "./RequestActionGroup";
import RequestActionApplication from "./RequestActionApplication";
import { RoleObject } from "../interfaces/ApplicationInterfaces";
import { AppEnvSetting } from "../ts/common";

interface CurrentUserApplicationRequest {
  displayedUser: UserApplicationRequests;
  id: string;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: string;
  tabIndex: string;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, tabIndex, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={tabIndex !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {tabIndex === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: "apps" | "groups") {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const NewRequest = (props: { requestsReload: number }) => {
  const [actionPopup, setActionPopup] = useState<"app" | "group" | "">("");
  const [currentUserApplication, setCurrentUserApplication] = useState<CurrentUserApplicationRequest>({
    displayedUser: {
      requestId: "",
      id: "",
      country: "",
      email: "",
      firstName: "",
      lastName: "",
    },
    id: "",
  });
  const [currentApplicationData, setCurrentApplicationData] = useState<
    Array<AllUserApplicationRequests>
  >([]);
  const [currentUserGroup, setCurrentUserGroup] = useState<UserGroupRequests>({
    id: "",
    groupId: "",
    userId: "",
    userCountry: "",
    status: "Pending",
    history: [],
    userEmail: "",
    userFirstName: "",
    userLastName: "",
  });
  const [currentGroupData, setCurrentGroupData] = useState<
    Array<UserGroupRequests>
  >([]);
  const [submissionPopup, setSubmissionPopup] = useState(false);
  const [submissionMessage, setSubmissionMessage] = useState("Please wait");
  const [loading, setLoading] = useState<boolean>(true);
  const [enabledTabs, setEnabledTabs] = useState<string[]>([]);
  const {adminCredentials, getToken} = useContext(AdminContext);
  const [tabIndex, setTabIndex] = useState<string>("");
  const handleChange = (event: React.SyntheticEvent, newValue: "apps" | "groups") => {
    setTabIndex(newValue);
  };
  let navigate = useNavigate();

  useEffect(() => {
    let showGroupsPage = false;
    if(adminCredentials){
      if(adminCredentials.isSuperAdmin) showGroupsPage = true;
      else {
        showGroupsPage = adminCredentials.roles.some((role: RoleObject)=>
          AppEnvSetting.pageViewAccess?.group?.includes(role.roleId) 
        ) ? true : false;
      }
    }else{
      showGroupsPage = false;
    }

    let tabs = [];
    if (!AppEnvSetting.disableAppProvisioning) {
      tabs.push("apps");
    }
    if (showGroupsPage && AppEnvSetting.showGroupsReviewRequests) {
      tabs.push("groups");
    }
    setEnabledTabs(tabs);
    setTabIndex(tabs.includes("apps") ? "apps" : enabledTabs[0]);
  }, [adminCredentials])

  useEffect(() => {

    /* https://stackoverflow.com/a/60907638 */
    let isMounted = true;
    if (tabIndex == "apps") {
      var apps: Array<string>;
    apps = adminCredentials.adminApplications.map((app: any) => app.id);
      if (currentApplicationData.length === 0 && isMounted) {
      setLoading(true);
      try {
        const body = {
          applicationIds: apps,
        };
        COSMOS_API.POST(
          body,
          POST_ENDPOINT.GetUserApplicationRequests,
          getToken()
        ).then((data) => {
          if (isMounted && data.ok && Array.isArray(data.respBody)) {
              setCurrentApplicationData(data.respBody);
          }
        });
      } catch (e) {
        console.log(e);
      }

      setLoading(false);
    }
    }
    else if (tabIndex == "groups") {
      if (currentGroupData.length === 0 && isMounted) {
        setLoading(true);
        try {
          const body = {
            status: "Pending",
            userId: "",
            groupId: ""
          };
          COSMOS_API.POST(
            body,
            POST_ENDPOINT.GetGroupAccessRequests,
            getToken()
          ).then((data) => {
            if (isMounted && data.ok && Array.isArray(data.respBody)) {
              setCurrentGroupData(data.respBody);
            }
          });
        } catch (e) {
          console.log(e);
        }

        setLoading(false);
      }
    }
    return () => {
      isMounted = false;
    };
  }, [props.requestsReload, tabIndex]);

  useEffect(() => {
    if (!submissionPopup) {
      setSubmissionMessage("Please wait");
      if (tabIndex == "apps") {
      let apps: Array<string> = adminCredentials.adminApplications.map(
        (app: any) => app.id
      );
      refreshRequests(apps);
    }
      else if (tabIndex == "groups") {
        refreshRequests([]);
      }
    }
  }, [submissionPopup]);

  const refreshRequests = async (appIds: Array<string>) => {
    setLoading(true);
    try {
      if (tabIndex == "apps") {
      const body = {
          applicationIds: appIds,
      };
      const data = await COSMOS_API.POST(
        body,
        POST_ENDPOINT.GetUserApplicationRequests,
        getToken()
      );
        setCurrentApplicationData(data.respBody);
      } else if (tabIndex == "groups") {
        const body = {
          status: "Pending",
          userId: "",
          groupId: ""
        };
        const data = await COSMOS_API.POST(
          body,
          POST_ENDPOINT.GetGroupAccessRequests,
          getToken()
        );
        setCurrentGroupData(data.respBody);
      }
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
  };

  const submitRequestAction = async (
    action: POST_ENDPOINT,
    body: any
  ) => {
    setActionPopup("");
    setSubmissionPopup(true);

    try {
      const status = await COSMOS_API.POST(body, action, getToken());
      if (!status.ok) {
        if (status.respBody.errorMessage) {
          setSubmissionMessage("An error has occurred: " + status.respBody.errorMessage);
        } else {
          setSubmissionMessage("An unexpected error has occured");
        }
      } else {
        setSubmissionMessage("Request successfully processed!");
      }
    } catch (e) {
      console.log(e);
    }
  };

  const userRedirect = (navigateTo: { pathname: string; search: string }) => {
    setActionPopup("");
    navigate(navigateTo);
  };

  return (
    <>
      {(enabledTabs.length > 1) &&
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabIndex} onChange={handleChange} aria-label="basic tabs example">
            {enabledTabs.includes("apps") && (<Tab value="apps" label="Application Approvals" {...a11yProps("apps")} />)}
            {enabledTabs.includes("groups") && (<Tab value="groups" label="Group Approvals" {...a11yProps("groups")} />)}
          </Tabs>
        </Box>
      }
      {enabledTabs.includes("apps") && (<CustomTabPanel tabIndex={tabIndex} index={"apps"}>
      {loading ? (
        <h3 className="working">Loading</h3>
      ) : (
        <div id="requests-table">
            {currentApplicationData.map((application) => {
            return application === undefined ||
              application.users.length === 0 ? (
              <div key={"no_application_requests_" + application.id}></div>
            ) : (
              <div key={application.id}>
                <h1>
                  {" "}
                  {adminCredentials.adminApplications.find(
                    (app) => app.id === application.id
                  ) !== undefined &&
                    adminCredentials.adminApplications.find(
                      (app) => app.id === application.id
                    )!.name}{" "}
                </h1>
                <TableContainer component={Paper}>
                  <Table>
                    <colgroup>
                      <col width="20%" />
                      <col width="20%" />
                      <col width="20%" />
                      <col width="30%" />
                      <col width="10%" />
                    </colgroup>
                    <TableHead>
                      <TableRow>
                        <TableCell> Firstname </TableCell>
                        <TableCell> Lastname </TableCell>
                        <TableCell> Country </TableCell>
                        <TableCell> Email </TableCell>
                        <TableCell> Actions </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {application === undefined ? (
                        <TableRow>
                          <TableCell colSpan={5}> Loading... </TableCell>
                        </TableRow>
                      ) : (
                        application.users.map((user: any) => (
                          <TableRow key={`${user.id}__${application.id}`}>
                            <TableCell> {user.firstName} </TableCell>
                            <TableCell> {user.lastName} </TableCell>
                            <TableCell>
                              {" "}
                              {
                                country_options.find(
                                  (country) => country.value === user.country
                                )?.label
                              }{" "}
                            </TableCell>
                            <TableCell>
                              {" "}
                              <Button
                                className="link-imitation"
                                onClick={() =>
                                  userRedirect({
                                    pathname: `/edit-user`,
                                    search: `?user=${user.id}&country=${user.country}`,
                                  })
                                }
                              >
                                {user.email}
                              </Button>{" "}
                            </TableCell>
                            <TableCell>
                              <Button
                                className="view-button button"
                                onClick={(e) => [
                                    setActionPopup("app"),
                                    setCurrentUserApplication({
                                    displayedUser: { ...user },
                                      id: application.id,
                                  }),
                                ]}
                              >
                                View
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            );
          })}
          {
              <RequestActionApplication
              actionPopup={actionPopup}
              setActionPopup={setActionPopup}
                currentUser={currentUserApplication.displayedUser}
              appName={
                adminCredentials.adminApplications.find(
                    (app) => app.id === currentUserApplication.id
                ) !== undefined ?
                adminCredentials.adminApplications.find(
                      (app) => app.id === currentUserApplication.id
                )!.name : ""
              }
                appId={currentUserApplication.id}
                submitRequestAction={submitRequestAction}
                userRedirect={userRedirect}
              />}
          </div>
        )}
      </CustomTabPanel>)}
      {enabledTabs.includes("groups") && <CustomTabPanel tabIndex={tabIndex} index={"groups"}>
        {loading ? (
          <h3 className="working">Loading</h3>
        ) : (
          <div id="requests-table">
            {currentGroupData.length > 0 &&
              <div>
                <TableContainer component={Paper}>
                  <Table>
                    <colgroup>
                      <col width="15%" />
                      <col width="15%" />
                      <col width="15%" />
                      <col width="15%" />
                      <col width="30%" />
                      <col width="10%" />
                    </colgroup>
                    <TableHead>
                      <TableRow>
                        <TableCell> Group Name </TableCell>
                        <TableCell> Firstname </TableCell>
                        <TableCell> Lastname </TableCell>
                        <TableCell> Country </TableCell>
                        <TableCell> Email </TableCell>
                        <TableCell> Actions </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {currentGroupData.map((group) => {
                        console.log("group :", group);
                        return (
                          <TableRow key={`${group.userId}__${group.groupId}`}>
                            <TableCell> {adminCredentials.allGroups[group.groupId].displayName} </TableCell>
                            <TableCell> {group.userFirstName} </TableCell>
                            <TableCell> {group.userLastName} </TableCell>
                            <TableCell>
                              {group.userCountry ?
                                country_options.find(
                                  (country) => country.value === group.userCountry
                                )?.label : " "
                              }
                            </TableCell>
                            <TableCell>
                              {group.userCountry ?
                                <Button
                                  className="link-imitation"
                                  onClick={() =>
                                    userRedirect({
                                      pathname: `/edit-user`,
                                      search: `?user=${group.userId}&country=${group.userCountry}`,
                                    })
                                  }
                                >
                                  {group.userEmail}
                                </Button> : group.userEmail}
                            </TableCell>
                            <TableCell>
                              <Button
                                className="button"
                                onClick={(e) => [
                                  setActionPopup("group"),
                                  setCurrentUserGroup(group),
                                ]}
                              >
                                View
                              </Button>
                            </TableCell>
                          </TableRow>)
                      })}



                    </TableBody>
                  </Table>
                </TableContainer>
              </div>

            }
            {Object.keys(adminCredentials.allGroups || {}).length > 0 && currentUserGroup.groupId != "" &&
              <RequestActionGroup
                actionPopup={actionPopup}
                setActionPopup={setActionPopup}
                currentUser={currentUserGroup}
                // @ts-ignore
                groupInfo={adminCredentials.allGroups[currentUserGroup.groupId]}
              submitRequestAction={submitRequestAction}
              userRedirect={userRedirect}
            />}
          </div>
        )}
      </CustomTabPanel>}

      {actionPopup == "" && (
            <PopUp
              msg={submissionMessage}
              setShowMsg={setSubmissionPopup}
              showMsg={submissionPopup}
              msgStyling={
                submissionMessage === "Please wait" ? "processing" : ""
              }
            />
      )}
    </>
  );
};

export default NewRequest;
